/* eslint-disable */

import * as runtime from '../runtime';
import type {
  EmbedConfigDto,
  EmbedCreateAccountDto,
  EmbedCreateAccountResponseDto,
  EmbedLoginDto,
  EmbedLoginResponseDto,
  EmbedMemberContextDto,
  EmbedProductDto,
  EmbedReleaseSpotHoldRequestDto,
  EmbedRequestCodeDto,
  EmbedRequestCodeResponseDto,
  EmbedRoomAvailabilityDto,
  EmbedSpotHoldRequestDto,
  EmbedUpdatePhoneDto,
  EmbedVerifyCodeDto,
  EmbedVerifyCodeResponseDto,
  ResultDto,
  SpotHoldResponseDto,
} from '../models';

export interface RequestSignInCodeRequest {
  orgId: number;
  embedRequestCodeDto: EmbedRequestCodeDto;
}

export interface VerifySignInCodeRequest {
  orgId: number;
  embedVerifyCodeDto: EmbedVerifyCodeDto;
}

export interface LoginWithPasswordRequest {
  orgId: number;
  embedLoginDto: EmbedLoginDto;
}

export interface CreateAccountRequest {
  orgId: number;
  embedCreateAccountDto: EmbedCreateAccountDto;
}

export interface UpdateMemberPhoneRequest {
  orgId: number;
  embedUpdatePhoneDto: EmbedUpdatePhoneDto;
}

export interface GetMemberContextRequest {
  orgId: number;
}

export interface GetEmbedConfigRequest {
  instanceId: string;
}

export interface GetEmbedProductsRequest {
  orgId: number;
}

export interface GetRoomAvailabilityRequest {
  orgId: number;
  roomId: string;
  startsAt?: string;
  endsAt?: string;
}

export interface CreateSpotHoldRequest {
  orgId: number;
  embedSpotHoldRequestDto: EmbedSpotHoldRequestDto;
}

export interface ReleaseSpotHoldRequest {
  orgId: number;
  embedReleaseSpotHoldRequestDto: EmbedReleaseSpotHoldRequestDto;
}

export class PublicEmbedsApi extends runtime.BaseAPI {

  async requestSignInCode(requestParameters: RequestSignInCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedRequestCodeResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/auth/request-code`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedRequestCodeDto,
    }, initOverrides);
    return response.json();
  }

  async verifySignInCode(requestParameters: VerifySignInCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedVerifyCodeResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/auth/verify-code`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedVerifyCodeDto,
    }, initOverrides);
    return response.json();
  }

  async loginWithPassword(requestParameters: LoginWithPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedLoginResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/auth/login`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedLoginDto,
    }, initOverrides);
    return response.json();
  }

  async createAccount(requestParameters: CreateAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedCreateAccountResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/auth/create-account`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedCreateAccountDto,
    }, initOverrides);
    return response.json();
  }

  async updateMemberPhone(requestParameters: UpdateMemberPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/me/phone`,
      method: 'PUT',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedUpdatePhoneDto,
    }, initOverrides);
    return response.json();
  }

  async getMemberContext(requestParameters: GetMemberContextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedMemberContextDto> {
    const response = await this.request({ path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/me`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async getEmbedConfig(requestParameters: GetEmbedConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedConfigDto> {
    const response = await this.request({ path: `/public/embeds/${encodeURIComponent(String(requestParameters.instanceId))}`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async getEmbedProducts(requestParameters: GetEmbedProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmbedProductDto>> {
    const response = await this.request({ path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/products`, method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

  async getRoomAvailability(requestParameters: GetRoomAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbedRoomAvailabilityDto> {
    const queryParameters: any = {};

    if (requestParameters.startsAt !== undefined) {
      queryParameters['startsAt'] = requestParameters.startsAt;
    }

    if (requestParameters.endsAt !== undefined) {
      queryParameters['endsAt'] = requestParameters.endsAt;
    }

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/rooms/${encodeURIComponent(String(requestParameters.roomId))}/availability`,
      method: 'GET',
      headers: {},
      query: queryParameters,
    }, initOverrides);
    return response.json();
  }

  async createSpotHold(requestParameters: CreateSpotHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpotHoldResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/spot-holds`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedSpotHoldRequestDto,
    }, initOverrides);
    return response.json();
  }

  async releaseSpotHold(requestParameters: ReleaseSpotHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/public/embeds/org/${encodeURIComponent(String(requestParameters.orgId))}/spot-holds/release`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.embedReleaseSpotHoldRequestDto,
    }, initOverrides);
    return response.json();
  }

}
